import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import { resolvePublicFileUrl } from "../../constants/api-urls";
import {
  buildInfraListingSpecItems,
  getInfraListingCategoryTrail,
  getInfraListingDetailHref,
  getInfraListingImagePath,
  getInfraListingLocation,
  getInfraListingPriceLabel,
  getInfraListingShareImage,
  getInfraTransactionLabel,
  resolveInfraListingRowBadge,
} from "../../utils/infrastructureListingCardHelpers";
import MarketplaceProductShareButton from "./MarketplaceProductShareButton";

export default function InfrastructureListingListRow({ item, detailTab = "real-estate" }) {
  const detailHref = getInfraListingDetailHref(item, detailTab);
  const imagePath = getInfraListingImagePath(item);
  const location = getInfraListingLocation(item);
  const priceLabel = getInfraListingPriceLabel(item);
  const specItems = buildInfraListingSpecItems(item).filter((spec) => !spec.empty);
  const badge = resolveInfraListingRowBadge(item);
  const categoryTrail = getInfraListingCategoryTrail(item);
  const transactionLabel = getInfraTransactionLabel(item.transactionType);

  return (
    <article className="marketplace-product-row marketplace-product-row--infra group">
      <div className="marketplace-product-row__media">
        {badge ? (
          <span className={`marketplace-product-row__badge ${badge.className}`}>{badge.label}</span>
        ) : null}
        <Link to={detailHref} className="marketplace-product-row__media-link">
          {imagePath ? (
            <img src={resolvePublicFileUrl(imagePath)} alt={item.title} loading="lazy" />
          ) : (
            <div className="marketplace-product-row__no-image">No image</div>
          )}
        </Link>
      </div>

      <div className="marketplace-product-row__body">
        <div className="marketplace-product-row__head">
          <div className="marketplace-product-row__head-left">
            <Link to={detailHref} className="marketplace-product-row__title">
              {item.title}
            </Link>

            {categoryTrail.length ? (
              <p className="marketplace-product-row__category-trail">{categoryTrail.join(" › ")}</p>
            ) : null}

            <div className="marketplace-product-row__seller">
              <span className="marketplace-product-row__company">{transactionLabel}</span>
              {location ? (
                <span className="marketplace-product-row__location">
                  <FaMapMarkerAlt aria-hidden /> {location}
                </span>
              ) : null}
            </div>
          </div>

          <div className="marketplace-product-row__head-right">
            {priceLabel ? <p className="marketplace-product-row__price">{priceLabel}</p> : null}
          </div>
        </div>

        {specItems.length ? (
          <dl
            className="marketplace-product-row__specs"
            style={{ gridTemplateColumns: `repeat(${Math.min(specItems.length, 4)}, minmax(0, 1fr))` }}
          >
            {specItems.map((spec) => (
              <div key={`${spec.label}-${spec.value}`} className="marketplace-product-row__spec">
                <dt>{spec.label}</dt>
                <dd>{spec.value}</dd>
              </div>
            ))}
          </dl>
        ) : null}

        <div className="marketplace-product-row__actions">
          <Link to={detailHref} className="marketplace-product-row__btn marketplace-product-row__btn--primary">
            View Listing
          </Link>
          <Link
            to={`${detailHref}&enquire=1`}
            className="marketplace-product-row__btn marketplace-product-row__btn--outline-dark"
          >
            Enquire Now
          </Link>
          <MarketplaceProductShareButton
            productId={item.id}
            title={item.title}
            sharePath={detailHref}
            imageUrl={getInfraListingShareImage(item)}
            companyName={item.categoryLabel || transactionLabel}
            description={item.description || `Infrastructure listing in ${location || "India"}`}
            triggerClassName="marketplace-product-row__btn marketplace-product-row__btn--outline marketplace-product-share__trigger"
          />
        </div>
      </div>
    </article>
  );
}
